
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getListOfCourses } from '../../api';
import '../../App.css';

const ListCourses = () => {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
            return;
        }

        fetchCourses();
    }, [navigate]);

    const fetchCourses = async () => {
        try {
            setLoading(true);
            setError('');
            const data = await getListOfCourses();
            setCourses(data || []);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch courses.');
            console.error('Error fetching courses:', err);
        } finally {
            setLoading(false);
        }
    };

    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: '#ccdff5',
            padding: '40px 20px'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                background: '#F6F6F6',
                borderRadius: '20px',
                padding: '40px',
                boxShadow: '0 4px 24px rgba(44, 62, 80, 0.08)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '30px'
                }}>
                    <h1 style={{
                        color: '#3c5a5d',
                        margin: 0,
                        fontSize: '2.5rem'
                    }}>
                        Courses List
                    </h1>
                    <button
                        onClick={() => navigate('/course')}
                        style={{
                            background: '#3c5a5d',
                            color: '#ffffff',
                            border: 'none',
                            fontSize: '1rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            padding: '12px 20px',
                            borderRadius: '10px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = '#2c4345'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = '#3c5a5d'; }}
                    >
                        + Create New Course
                    </button>
                </div>

                {error && (
                    <div style={{
                        color: '#dc2626',
                        marginBottom: '20px',
                        padding: '12px',
                        background: '#fee2e2',
                        borderRadius: '8px',
                        fontSize: '14px'
                    }}>
                        {error}
                    </div>
                )}

                {loading ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        Loading courses...
                    </div>
                ) : courses.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        No courses found. Create your first course!
                    </div>
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                        gap: '24px'
                    }}>
                        {courses.map((course, index) => (
                            <div
                                key={course.id || index}
                                onClick={() => navigate(`/course-edit/${course.id || course._id || index}`)}
                                style={{
                                    background: '#e5eff8',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    border: '1px solid #cfd8dc',
                                    boxShadow: '0 2px 12px rgba(44, 62, 80, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(44, 62, 80, 0.08)';
                                }}
                            >
                                {course.image && (
                                    <img
                                        src={course.image}
                                        alt={course.name}
                                        style={{
                                            width: '100%',
                                            height: '200px',
                                            objectFit: 'cover',
                                            borderRadius: '12px',
                                            marginBottom: '16px'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                )}
                                <h3 style={{
                                    color: '#3c5a5d',
                                    marginBottom: '12px',
                                    fontSize: '1.5rem',
                                    fontWeight: '600'
                                }}>
                                    {course.name || 'Untitled Course'}
                                </h3>
                                <p style={{
                                    color: '#707F81',
                                    marginBottom: '16px',
                                    fontSize: '0.95rem',
                                    lineHeight: '1.6',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden'
                                }}>
                                    {course.description || 'No description available'}
                                </p>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '16px',
                                    paddingTop: '16px',
                                    borderTop: '1px solid #cfd8dc'
                                }}>
                                    <span style={{
                                        background: course.level === 'beginner' ? '#dbeafe' :
                                                   course.level === 'intermediate' ? '#fef3c7' : '#fce7f3',
                                        color: course.level === 'beginner' ? '#1e40af' :
                                              course.level === 'intermediate' ? '#92400e' : '#9f1239',
                                        padding: '6px 12px',
                                        borderRadius: '20px',
                                        fontSize: '0.85rem',
                                        fontWeight: '600',
                                        textTransform: 'capitalize'
                                    }}>
                                        {course.level || 'beginner'}
                                    </span>
                                    {course.chapters && (
                                        <span style={{
                                            color: '#707F81',
                                            fontSize: '0.9rem'
                                        }}>
                                            {course.chapters.length} {course.chapters.length === 1 ? 'chapter' : 'chapters'}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ListCourses;
